/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
/*
 * @Description: 画布header退出按钮提示弹窗
 * @Author: yang chenglin
 */
import React, { useState } from 'react';
import { Dialog, Button } from '@alifd/next';
import styles from './index.module.scss';

/**
 * @param type 弹窗类型：WARN 警告  ERROR 错误  SUCCESS 成功
 * @param title 弹窗标题名称
 * @param promptInfo 弹窗提示信息
 * @param flag 显示/隐藏弹窗标识
 * @param confirmHandel 确认方法
 * @param cancelHandel 取消方法
 * @param saveHandel 保存并退出方法
 * @returns 警告弹窗
 */
const ConfirmDialog = (props) => {
  const { type, title, promptInfo, flag, confirmHandel, cancelHandel, saveHandel } = props;
  return (
    <div>
      <Dialog
        footer={false}
        title={title}
        shouldUpdatePosition
        visible={flag}
        className={styles.dialog}
        onClose={cancelHandel}
      >
        <div>
          {type === 'WARN' && (
            <div
              className={`iconfont icon-icon4-35 ${styles.icon} ${styles.warn}`}
            />
          )}
          {type === 'ERROR' && (
            <div
              className={`iconfont icon-icon4-29 ${styles.icon} ${styles.error}`}
            />
          )}
          {type === 'SUCCESS' && (
            <div
              className={`iconfont icon-icon4-35 ${styles.icon} ${styles.success}`}
            />
          )}
          <div className={styles.word}>
            {type === 'WARN' && <span>重要提示！</span>}
            {type === 'ERROR' && <span>操作驳回！</span>}
            {type === 'SUCCESS' && <span>操作成功！</span>}
            <br />
            <span>{promptInfo}</span>
          </div>
          <div style={{ clear: 'both' }} />
          <div className={styles.btn}>
            <Button
              type="normal"
              className={`cancel-btn ${styles.mr10} ${styles.w88}`}
              onClick={cancelHandel}
            >
              取消
            </Button>
            <Button
              type="normal"
              className={`cancel-btn ${styles.mr10} ${styles.w88}`}
              onClick={confirmHandel}
            >
              直接退出
            </Button>
            <Button
              type="primary"
              className={`submit-btn`}
              onClick={saveHandel}
            >
              保存并退出
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ConfirmDialog;
